// `EnhancedDatadeal` is the internal report and component identifier. These
// messages are contributor-facing and therefore use the 3D Partner Program name.
const PRESENTATIONS = {
  opted_in_qualifies: {
    tone: 'qualified',
    icon: 'fa-certificate',
    status: 'Qualified',
    optInStatus: 'Opted in',
    message: "You've qualified for the 3D Partner Program.",
    detail: 'You meet the publishing requirement.',
    optedIn: true,
    qualifies: true,
  },
  opted_in_needs_progress: {
    tone: 'progress',
    icon: 'fa-line-chart',
    status: 'Making progress',
    optInStatus: 'Opted in',
    message: "You're on the path to qualifying for the 3D Partner Program.",
    optedIn: true,
    qualifies: false,
  },
  opted_out_qualifies: {
    tone: 'action-required',
    icon: 'unlock-award',
    status: 'Action required',
    optInStatus: 'Opt-in required',
    message: "You've qualified for the 3D Partner Program.",
    detail: 'Opt in to receive enhanced benefits on eligible content.',
    optedIn: false,
    qualifies: true,
  },
  opted_out_needs_progress: {
    tone: 'get-started',
    icon: 'fa-bar-chart',
    status: 'Get started',
    optInStatus: 'Opt-in required',
    message: 'Opt in and keep publishing to qualify for the 3D Partner Program.',
    optedIn: false,
    qualifies: false,
  },
};

export function enhancedDatadealPresentation(progress) {
  return PRESENTATIONS[progress.progress_state] || PRESENTATIONS.opted_out_needs_progress;
}
